import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

const states = {
  name: 'states',
  inputShow: gql`
    query states($input: StateQueryInput) {
      states(input: $input) {
        id
        name
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Rates',
    label: 'States',
  },
};

export default states;
